import type { InAppNotification } from "./api";

/** Typed TanStack-Router link target for a reminder's "Zum Vorfall" action. */
export interface NotificationTarget {
  to: "/incidents/$id" | "/incidents/$id/postmortem";
  params: { id: string };
}

/**
 * Where a reminder navigates to: the postmortem page when it references a
 * follow-up task (that is where the tasks live), the incident detail when it
 * only references an incident, and nowhere (null - no link is rendered) when
 * it carries no incident reference at all. A task reference without an
 * incident cannot be routed and also yields null.
 */
export function notificationTarget(
  notification: Pick<InAppNotification, "incidentId" | "followupTaskId">,
): NotificationTarget | null {
  if (!notification.incidentId) return null;
  return {
    to: notification.followupTaskId
      ? "/incidents/$id/postmortem"
      : "/incidents/$id",
    params: { id: notification.incidentId },
  };
}
